import { useState, useEffect } from 'react';

const useScrollClass = (initialClass, toggleClass) => {
    const [currentClass, setCurrentClass] = useState(initialClass);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 0) {
                setCurrentClass(`${initialClass} ${toggleClass}`);
            } else {
                setCurrentClass(initialClass);
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Initial check
        handleScroll();

        // Clean up function
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [initialClass, toggleClass]);

    return currentClass;
};

export default useScrollClass;
